import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_banner = _resolveComponent("top-banner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_top_banner, {
      title: _ctx.title,
      "show-back-button": _ctx.showBackButton,
      "show-log-off": _ctx.showLogOff,
      "navigation-items": _ctx.navigationItems
    }, _createSlots({ _: 2 }, [
      (_ctx.$slots.navigation)
        ? {
            name: "navigation",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "navigation")
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "show-back-button", "show-log-off", "navigation-items"]),
    _createElementVNode("div", {
      id: _ctx.container,
      class: "flex-node-col"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1)
  ], 64))
}